import reasons from './moderation_reasons.json';

export const POST_LOCK_REASONS = reasons.POST_LOCK_REASONS;
export const POST_ADMIN_DECISION_REASONS = reasons.POST_ADMIN_DECISION_REASONS;
export const POST_REPORT_REASONS = reasons.POST_REPORT_REASONS;
export const REVIEW_ADMIN_DECISION_REASONS = reasons.REVIEW_ADMIN_DECISION_REASONS;
export const REVIEW_REPORT_REASONS = reasons.REVIEW_REPORT_REASONS;
